<template>
  <v-container
    v-if="dataSource"
    class="bg-white"
    style="width: 400px; height: 250px">
    <!-- <v-row>
      <v-col class="text-right">
        <v-btn
          class="mr-2 text-capitalize"
          color="primary"
          flat
          prepend-icon="mdi-tray-arrow-down"
          rounded="xl"
          variant="outlined"
          @click="downloadPng">
          {{ $t(`actions.download`) }}
        </v-btn>
      </v-col>
    </v-row> -->

    <Bar
      :key="props.spaceId"
      ref="chartRef"
      :data="chartData"
      :options="chartOptions"
      style="background-color: transparent" />
  </v-container>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import { useTranslation } from "i18next-vue";
import { Bar } from "vue-chartjs";
import ChartDataLabels from "chartjs-plugin-datalabels";
import axios from "axios";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  Colors
} from "chart.js";
import {
  chartFields,
  prepareBreakdownChartData,
  smallCostBreakDownChartOptions,
  customCanvasBackgroundColor,
  downloadChartPng
} from "@/utils/costBreakdown/costBreakdownChart";

import { watch } from "vue";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ChartDataLabels,
  customCanvasBackgroundColor,
  Colors
);

const { t } = useTranslation();

const dataSource = ref(null);
const chartRef = ref(null);
const title = ref(null);

const titleField = computed(() => {
  switch ("part") {
    case "part":
      return props.parentId ? "name" : "variant_name";
    case "manufacturingStep":
      return "manufacturing_step_name";
    default:
      return "name";
  }
});

const props = defineProps({
  spaceId: String
});

onMounted(() => {
  init();
});

watch(props.nodeId, () => {
  init();
});

function init() {
  axios
    .get("/api/element/" + props.spaceId + "/cost-breakdown")
    .then((response) => {
      let prefix = "";
      // if (response.data.length < 1) {
      //   prefix = "No data";
      //   return;
      // }
      prefix = response.data?.[0]?.name || "No data";
      dataSource.value = response.data;

      title.value = prefix + " - " + t("entities.variant.tabs.costBreakdown");
    });
}

const downloadPng = () => downloadChartPng(chartRef.value.$el);

const isMultiple = computed(() => Array.isArray(dataSource.value));

const datasets = computed(() => {
  if (!dataSource.value) return [];

  if (isMultiple.value) {
    return dataSource.value.map((part) => {
      return {
        data: prepareBreakdownChartData(part, "part"),
        label: part.variant_name
      };
    });
  } else {
    return [
      {
        data: prepareBreakdownChartData(dataSource.value, "part"),
        backgroundColor: "#CADDF9"
      }
    ];
  }
});

const chartData = computed(() => {
  return {
    labels: chartFields("part").map((field) =>
      t(`entities.${"part"}.fields.${field}`)
    ),
    datasets: datasets.value
  };
});

const chartOptions = computed(() =>
  smallCostBreakDownChartOptions(title.value)
);
</script>
